export default "__VITE_ASSET__O5$LU6Pp__"